import "../../../assets/styles/components/Header.scss";
import { MobileNavIcon } from "../nav";

interface Props {
    name?: string;
    image?: string;
    isPartnered: boolean;
    showNavigationDrawerIcon?: boolean;
}

/**
 * Header is a React component that provides a configurable header section
 * for the application. It dynamically displays contact information and an image
 * based on the supplied props. The component adjusts its content and layout
 * based on whether the user is a partnered supplier and whether to show
 * navigation drawer icons on smaller screens.
 *
 */
function Header({
    name,
    image,
    isPartnered,
    showNavigationDrawerIcon
}: Readonly<Props>) {
    function renderImage() {
        if (image) {
            return (
                <img className="header-contact-image" src={image} alt={name} />
            );
        } else {
            return <img className="header-contact-no-image"></img>;
        }
    }

    function showSupplierInfo() {
        return (
            <>
                <div className="header-contact">
                    <div className="header-contact-title">
                        <i className="fa-solid fa-phone" style={{marginRight: "10px"}}></i>
                        Beratung kontaktieren
                    </div>
                </div>
            </>
        );
    }

    function showNonSupplierInfo() {
        return (
            <>
                <div className="header-contact">
                    <div className="header-contact-title">
                        <i className="fa-solid fa-phone" style={{marginRight: "10px"}}></i>
                        Beratung kontaktieren
                    </div>
                </div>
            </>
        );
    }

    return (
        <div className="header-container">
            <div className="header">
                <a>
                    <div className="header-logo"></div>
                </a>
                <div className="header-contact-container">
                    {isPartnered ? showSupplierInfo() : showNonSupplierInfo()}
                    {!isPartnered && showNavigationDrawerIcon && (
                        <MobileNavIcon className="show-small-screen"></MobileNavIcon>
                    )}
                </div>
            </div>
            <div className="header-banner"></div>
        </div>
    );
}

export default Header;
